import React from "react";
import { format } from "date-fns";
import { getFullName, renderValue } from "utils/renderCompanyCell";
import { UserInformationSection } from "pages/Users/UserProfileInfo/styled";
import StatusPillButtons from "components/Buttons/StatusPillButtons";

export const ProfileOverview = ({ creatorUserDetails }) => {
  const renderUrl = (url) => {
    if (!url) return "-";
    return url ? (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="link_color"
      >
        {url}
      </a>
    ) : (
      <p>-</p>
    );
  };

  const bannerColor = JSON.parse(creatorUserDetails?.banner_color || "{}");
  return (
    <>
      <UserInformationSection>
        <h3 className="section-title">Identity & Core Profile</h3>
        <ul className="user-details-grid">
          <li>
            <span>Creator ID</span>
            <p>{creatorUserDetails?.creator_id}</p>
          </li>
          <li>
            <span>Name</span>
            <p>{renderValue(getFullName(creatorUserDetails))}</p>
          </li>

          <li>
            <span>Email</span>
            <div className="profile-info">
              <p>{renderValue(creatorUserDetails?.email)}</p>
            </div>
          </li>
          <li>
            <span>Email verified at</span>
            <p>
              {renderValue(
                creatorUserDetails?.email_verified_at
                  ? format(
                      new Date(creatorUserDetails.email_verified_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
          <li>
            <span>Country Code</span>
            <p>{renderValue(creatorUserDetails?.country_code)}</p>
          </li>
          <li>
            <span>Phone Number</span>
            <p>+91 {renderValue(creatorUserDetails?.phone_number)}</p>
          </li>
          <li>
            <span>Full-Time Profession</span>
            <p>
              {renderValue(creatorUserDetails?.profession?.profession_name)}
            </p>
          </li>
        </ul>
      </UserInformationSection>

      <UserInformationSection>
        <h3 className="section-title">Account Status & Access Control</h3>
        <ul className="user-details-grid">
          <li>
            <span>Status</span>
            <StatusPillButtons status={creatorUserDetails?.status} />
          </li>
          <li>
            <span>Work Mode</span>
            <p>{renderValue(creatorUserDetails?.work_mode)}</p>
          </li>
          <li>
            <span>Is Creator Onboarded</span>
            <StatusPillButtons
              status={creatorUserDetails?.is_creator_onboarded ? "Yes" : "No"}
            />
          </li>
          <li>
            <span>Is Onboarding Steps Completed</span>
            <StatusPillButtons
              status={
                creatorUserDetails?.is_onboarding_steps_completed ? "Yes" : "No"
              }
            />
          </li>
          <li>
            <span>Is Biz Unlocked</span>
            <StatusPillButtons
              status={creatorUserDetails?.is_biz_unlocked ? "Yes" : "No"}
            />
          </li>
          <li>
            <span>Skip Criteria Check for Social</span>
            <StatusPillButtons
              status={
                creatorUserDetails?.skip_criteria_check_for_social
                  ? "Yes"
                  : "No"
              }
            />
          </li>
          <li>
            <span>Delete Requested At</span>
            <p>
              {renderValue(
                creatorUserDetails?.delete_requested_at
                  ? format(
                      new Date(creatorUserDetails.delete_requested_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
        </ul>
      </UserInformationSection>

      <UserInformationSection>
        <h3 className="section-title">Profile Completeness & Source</h3>
        <ul className="user-details-grid">
          <li>
            <span>Profile Completion Percentage</span>
            <p>
              {creatorUserDetails?.profile_completion_percentage
                ? `${creatorUserDetails.profile_completion_percentage}%`
                : "-"}
            </p>
          </li>
          <li>
            <span>Unseen Notification Count</span>
            <p>{renderValue(creatorUserDetails?.unseen_notification_count)}</p>
          </li>
          <li>
            <span>Sleep From</span>
            <p>{renderValue(creatorUserDetails?.sleep_from)}</p>
          </li>
          <li>
            <span>Sleep To</span>
            <p>{renderValue(creatorUserDetails?.sleep_to)}</p>
          </li>
        </ul>
      </UserInformationSection>

      <UserInformationSection>
        <h3 className="section-title">Media & Branding Assets</h3>
        <ul className="user-details-grid">
          <li>
            <span>Profile Picture</span>
            {renderUrl(creatorUserDetails?.profile_pic)}
          </li>
          <li>
            <span>Profile Picture (100×100)</span>
            {renderUrl(creatorUserDetails?.profile_pic_100_100)}
          </li>
          <li>
            <span>Profile Picture (200×200)</span>
            {renderUrl(creatorUserDetails?.profile_pic_200_200)}
          </li>
          <li>
            <span>Profile Picture (400×400)</span>
            {renderUrl(creatorUserDetails?.profile_pic_400_400)}
          </li>
          <li>
            <span>Profile Picture (800×800)</span>
            {renderUrl(creatorUserDetails?.profile_pic_800_800)}
          </li>
          <li>
            <span>Banner Image</span>
            {renderUrl(creatorUserDetails?.banner_image)}
          </li>
          <li>
            <span>Banner Color</span>
            <div className="render-banner-color">
              {bannerColor && bannerColor.length
                ? bannerColor.map((color, index) => (
                    <div className="color-item" key={index}>
                      <span style={{ backgroundColor: color }}></span>
                      <p>{color}</p>
                    </div>
                  ))
                : ""}
            </div>
          </li>

          <li>
            <span>Created At</span>
            <p>
              {creatorUserDetails?.created_at
                ? format(
                    new Date(creatorUserDetails.created_at),
                    "MMM dd, yyyy h:mm a"
                  )
                : "-"}
            </p>
          </li>
          <li>
            <span>Updated At</span>
            <p>
              {renderValue(
                creatorUserDetails?.updated_at
                  ? format(
                      new Date(creatorUserDetails.updated_at),
                      "MMM dd, yyyy h:mm a"
                    )
                  : "-"
              )}
            </p>
          </li>
        </ul>
      </UserInformationSection>
    </>
  );
};
